import { RouteObject } from 'react-router-dom';

import { Drivers } from '@/pages/Fleet';
import { ViewDriver, NewDriver, EditDriver } from '@/pages/Fleet/Drivers/pages';

export const DriversRoutes: RouteObject[] = [
  {
    path: 'drivers',
    element: <Drivers />,
  },
  {
    path: 'drivers/profile/:id',
    element: <ViewDriver />,
  },
  {
    path: 'drivers/profile/:id/edit',
    element: <EditDriver />,
  },
  {
    path: 'drivers/new',
    element: <NewDriver />,
  },
];
